import { shouldSuppressAxiosError } from "@/Library/composables/Utils/useAxiosError";

const handleHttpStatus = (event) => {
  const original = event?.originalError;

  // If axios interceptor marked it, suppress immediately
  if (original && original.__suppressBugsnag) {
    throw "Suppress Bugsnag";
  }

  if (original && shouldSuppressAxiosError(original)) {
    throw "Suppress handled axios Bugsnag";
  }
};

const handleAnnoyingErrors = (event) => {
  const original = event?.originalError;
  const message = original?.message ?? "";

  if (message.includes("dayIndex")) {
    throw "Suppress dayIndex Bugsnag";
  }
};

export const install = (app) => {
  if (import.meta.env.VITE_BUGSNAG_API_KEY) {
    import("@bugsnag/js").then(({ default: Bugsnag }) => {
      import("@bugsnag/plugin-vue").then(({ default: BugsnagPluginVue }) => {
        Bugsnag.start({
          apiKey: import.meta.env.VITE_BUGSNAG_API_KEY,
          plugins: [new BugsnagPluginVue()],
          releaseStage: import.meta.env.MODE,
          onError: (event) => {
            try {
              handleHttpStatus(event);
              handleAnnoyingErrors(event);

              return true;
            } catch (_e) {
              return false;
            }
          },
        });
        const bugsnagVue = Bugsnag.getPlugin("vue");
        if (bugsnagVue && typeof bugsnagVue.installVue === "function") {
          bugsnagVue.installVue(app);
        } else if (bugsnagVue && typeof app.use === "function") {
          // Fallback for any unexpected plugin shape
          app.use(bugsnagVue);
        }
      });
      // import("@bugsnag/browser-performance").then((BugsnagPerformance) => {
      //   BugsnagPerformance.start(import.meta.env.VITE_BUGSNAG_API_KEY);
      // });
    });
  }
};

export default {};
